import React from 'react';
import { Box } from '@mui/material';
import BasicInfoSection from './BasicInfoSection';
import RolePermissionsSection from './RolePermissionsSection';
import RegionProjectsSection from './RegionProjectsSection';

/**
 * CreateUserForm Component
 * Main form component with all sections
 */
const CreateUserForm = ({
  formData,
  errors,
  whatsappError,
  projects,
  loadingProjects,
  availableRegions,
  roles,
  onInputChange,
  onWhatsAppChange,
  onWhatsAppKeyPress,
  onRoleChange,
  onProjectsChange,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <BasicInfoSection
        formData={formData}
        errors={errors}
        whatsappError={whatsappError}
        onInputChange={onInputChange}
        onWhatsAppChange={onWhatsAppChange}
        onWhatsAppKeyPress={onWhatsAppKeyPress}
      />
      <RolePermissionsSection
        formData={formData}
        errors={errors}
        roles={roles}
        onInputChange={onInputChange}
        onRoleChange={onRoleChange}
      />
      <RegionProjectsSection
        formData={formData}
        projects={projects}
        loadingProjects={loadingProjects}
        availableRegions={availableRegions}
        onInputChange={onInputChange}
        onProjectsChange={onProjectsChange}
      />
    </Box>
  );
};

export default CreateUserForm;

